module.exports = __webpack_public_path__ + "static/media/search.e867c1ee.svg";